import ReportsPage from "../report/report";

function EightDForms() {
  // No props needed - ReportsPage will determine mode from URL
  return <ReportsPage />;
}

export default EightDForms;
